import type { FirebaseOptions } from "firebase/app";
import { z } from "zod";

const firebaseSchema = z
  .object({
    apiKey: z.string(),
    authDomain: z.string(),
    projectId: z.string(),
    storageBucket: z.string(),
    messagingSenderId: z.string(),
    appId: z.string(),
    measurementId: z.string().optional()
  })
  .passthrough();

function parseFirebaseConfig(raw: string | undefined): FirebaseOptions | null {
  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw);
    const config = firebaseSchema.parse(parsed);
    return config;
  } catch (error) {
    console.warn("Failed to parse Firebase config. Falling back to null.", error);
    return null;
  }
}

const apiBaseFallback = "/api";

export const appEnv = {
  apiBaseUrl:
    import.meta.env.VITE_API_BASE_URL && import.meta.env.VITE_API_BASE_URL.length > 0
      ? import.meta.env.VITE_API_BASE_URL
      : apiBaseFallback,
  firebase: parseFirebaseConfig(import.meta.env.VITE_FIREBASE_CONFIG),
  firebaseMeasurementId:
    import.meta.env.VITE_FIREBASE_MEASUREMENT_ID &&
    import.meta.env.VITE_FIREBASE_MEASUREMENT_ID.length > 0
      ? import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
      : undefined,
  projectId:
    import.meta.env.VITE_PROJECT_ID && import.meta.env.VITE_PROJECT_ID.length > 0
      ? import.meta.env.VITE_PROJECT_ID
      : undefined,
  liveProfile:
    import.meta.env.VITE_LIVE_PROFILE && import.meta.env.VITE_LIVE_PROFILE.length > 0
      ? import.meta.env.VITE_LIVE_PROFILE
      : "default"
} as const;

